import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { loading } from '../../../actions/sessions';

export default function NetXIntro() {
  const history = useHistory();
  const dispatch = useDispatch();
  const merchant = useSelector((state) => state.entities.get('merchant').first());

  useEffect(() => {
    dispatch(loading(false));
  }, []);

  return (
    <div role="main" id="content" className="text-center mb-6">
      <div className="shadow border-light-gray mobile:border-none xxs:rounded-lg px-4 pt-7 pb-5 my-6">
        <p className="font-avenir-black text-2xl text-navy-blue text-center mt-4">
          Welcome to Credit Key
        </p>
        <p className="my-1 text-sm mobile:text-base text-center">
          Please select your business type to continue:
        </p>
        <div className="my-4">
          <div
            className="flex items-center justify-between p-4 cursor-pointer w-full rounded-xl border border-[0.25px] border-extra-light-gray hover:bg-light-blue text-light-blue hover:text-white my-3"
            onClick={() => history.push('/init/new_user')}
          >
            <div className="flex items-center">
              <div className="fa-3x mr-3 hidden mobile:inline">
                <span className="fa-layers fa-fw">
                  <FontAwesomeIcon
                    icon="circle"
                  />
                  <FontAwesomeIcon
                    icon={['fal', 'building']}
                    inverse
                    transform="shrink-10"
                    className="text-primary-blue"
                  />
                </span>
              </div>
              <div className="flex flex-col items-start tracking-wide mb-1 text-black">
                <h2 className="font-avenir-black text-sm mobile:text-[1.05rem] text-left mb-3">
                  Enterprise, Government, Non-profit
                </h2>
                <p className="text-xs mobile:text-sm text-left mobile:text-center">
                  Select if ANY of the following apply:
                </p>
                <ul className="text-xs mobile:text-sm text-left mt-1 text-dark-gray list-disc">
                  <li className="ml-2">Over $5 Million+ annual revenue</li>
                  <li className="ml-2">Publicly traded company</li>
                  <li className="ml-2">Government / Municipality</li>
                  <li className="ml-2">School or educational institution</li>
                </ul>
                <p className="mt-3 text-sm font-avenir-black">Net 30 terms</p>
              </div>
            </div>
            <FontAwesomeIcon icon={['fal', 'chevron-right']} className="text-sm mobile:text-base mr-2 text-black" />
          </div>
          <div
            className="flex items-center justify-between p-4 cursor-pointer w-full rounded-xl border border-[0.25px] border-extra-light-gray hover:bg-light-blue text-light-blue hover:text-white my-3"
            onClick={() =>
              (window.location.href = process.env.REACT_APP_APPLY_URL + '/' + merchant.slug)
            }
          >
            <div className="flex items-center">
              <div className="fa-3x mr-3 hidden mobile:inline">
                <span className="fa-layers fa-fw">
                  <FontAwesomeIcon
                    icon="circle"
                  />
                  <FontAwesomeIcon
                    icon={['fal', 'shop']}
                    inverse
                    transform="shrink-10"
                    className="text-primary-blue"
                  />
                </span>
              </div>
              <div className="flex flex-col items-start tracking-wide mb-1 text-black">
                <h2 className="font-avenir-black text-sm mobile:text-[1.05rem] text-left mb-3">
                  Small to Medium Business
                </h2>
                <ul className="text-xs mobile:text-sm text-left mt-1 text-dark-gray list-disc">
                  <li className="ml-2">In business over 1 year</li>
                  <li className="ml-2">$40,000+ annual revenue</li>
                  <li className="ml-2">Personal FICO score over 600</li>
                </ul>
                <p className="mt-3 text-sm  font-avenir-black">Net 30 or up to 12 month terms</p>
              </div>
            </div>
            <FontAwesomeIcon icon={['fal', 'chevron-right']} className="text-sm mobile:text-base mr-2 text-black" />
          </div>
        </div>
        <p className="font-avenir-medium text-sm mt-6">
          Already have a Credit Key account?{' '}
          <span
            className="cursor-pointer text-primary-blue ml-1"
            onClick={() => history.push('/init/existing_user')}
          >
            Sign In
          </span>
        </p>
      </div>
    </div>
  );
}
